export { default } from "./src/accordion";
export type { UniformAccordionProps } from "./src/accordion";
